import L from 'leaflet';
import { isEmpty } from 'lodash';
import { readWaypointListOptions } from '../client/waypoint-style-chooser';

/**
 * Add the appropiate control for editing the mission geometry to the leaflet map
 * when the button to edit the geometry has been activated.
 *
 * @param {*} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object} arg.readWPList - The feature collection with the waypoints to draw.
 * @param {?object} arg.readWaypointListLayer - The layer with the waypoint list from the RPA.
 * @param {?object} arg.geoJSONWaypointListLayer - The layer with the waypoint list.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @returns {object} The layer where the waypoints from the RPA are painted.
 */
const drawReceivedWaypointList = ({
  leafletMap,
  readWPList,
  readWaypointListLayer,
  geoJSONWaypointListLayer,
  isUpdate = false
}) => {
  let newGeoJSONReadWaypointListLayer = '';
  if (!isUpdate) {
    newGeoJSONReadWaypointListLayer = L.geoJSON(null, readWaypointListOptions).addTo(leafletMap);
    const overlayMaps = {
      'Sent WPList': geoJSONWaypointListLayer,
      'Read WPList': newGeoJSONReadWaypointListLayer
    };
    L.control.layers(null, overlayMaps).addTo(leafletMap);
  } else {
    newGeoJSONReadWaypointListLayer = readWaypointListLayer;
    newGeoJSONReadWaypointListLayer.clearLayers();
  }
  if (!isEmpty(readWPList)) {
    newGeoJSONReadWaypointListLayer.addData(readWPList);
  }
  return newGeoJSONReadWaypointListLayer;
};

export default drawReceivedWaypointList;
